import { render, staticRenderFns } from "./TypeOne.vue?vue&type=template&id=25699b14&scoped=true"
import script from "./TypeOne.vue?vue&type=script&lang=js"
export * from "./TypeOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25699b14",
  null
  
)

export default component.exports